import type { ReactNode, SVGProps } from 'react';

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
  size?: number;
  /** Accessible name. Without it the icon is decorative (`aria-hidden`). */
  label?: string;
};

type IconBaseProps = IconProps & { children: ReactNode; filled?: boolean };

/** 24px grid, stroke 2, round caps/joins, currentColor (DESIGN.md §4 Icons). */
export function IconBase({
  size = 18,
  label,
  children,
  strokeWidth = 2,
  filled = false,
  ...rest
}: IconBaseProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      {...rest}
    >
      {children}
    </svg>
  );
}
